// File: `app/javascript/controllers/product_module/safari.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initSafari(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        create_id_for_product,
        service_by_dealer,
        modality_info,
        get_contract,
        setSessionVar,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage,
        showDescriptionModal,
        excursion_location_selector = '#excursion_location',
        excursion_lang_selector = '#excursion_lang'
    } = deps;

    if (!form_type_send) return;

    // Selectores
    const safari_to = $('#safari_to');
    const safari_date = $('#safari_date');
    const safari_type = $('#safari_type');
    const safari_modality = $('#safari_modality');
    const safari_pax_block = $('#safari_pax_block');
    const safari_pax = $('#safari_pax');
    const safari_cantidad_block = $('#safari_cantidad_block');
    const safari_cantidad = $('#safari_cantidad');
    const safari_adult_childrens = $('#safari_adult_childrens');
    const safari_adultos = $('#safari_adultos');
    const safari_childrens = $('#safari_childrens');
    const safari_btn_info = $('#safari_btn_info');

    safari_date.prop('disabled', true);
    safari_type.prop('disabled', true).select2({ theme: 'bootstrap' });
    safari_modality.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_modality')
    });
    safari_pax.prop('disabled', true).select2({ theme: 'bootstrap' });

    safari_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: `${location.origin}/${sessionStorage.getItem('locale')}/destination`,
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                params.page = params.page || 1;
                const result = [];
                (data.rows || []).forEach(elem => {
                    result.push({ id: `${elem.code}|${elem.id}|${elem.name}`, text: elem.name });
                });
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        const parts = (e.target.value || '').split("|");
        const data_safari_to = parts[1];

        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', parts[1]);
        create_array_for_product('destination_code', parts[0]);
        create_array_for_product('text_destination', parts[2]);

        safari_type.empty();
        safari_modality.empty();
        safari_pax.empty();
        safari_date.val('');
        $(excursion_location_selector).val('');
        $(excursion_lang_selector).empty();
        safari_btn_info[0].classList.add('ocultar');
        let safari_btn_info_desc = '';

        // FIX (2026-08-10): bloquear el formulario mientras service_by_dealer carga por
        // detrás. withElementBlock garantiza desbloqueo en éxito/error/timeout.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            service_by_dealer(data_safari_to, form_type_send),
            { timeout: 30000 }
        ).then(sbd => {
            const result = (sbd.services || []).map(elem => ({
                id: `${elem.id}|${elem.code}|${elem.reservation_time}|${sbd.dealer_code}|${sbd.dealer_name}|${sbd.dealer_id}|${elem.min_reservation_amount}|${elem.max_reservation_amount}`,
                text: elem.name
            }));

            safari_modality.empty();
            safari_pax_block[0].classList.remove('ocultar');
            safari_cantidad_block[0].classList.add('ocultar');
            safari_adult_childrens[0].classList.add('ocultar');
            safari_btn_info[0].classList.add('ocultar');
            safari_btn_info_desc = '';

            if (!result.length) return;

            const product_type = result[0].id.split("|");
            const product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            const excursion_location_container = $('#excursion_location_container');
            const excursion_location = $(excursion_location_selector);
            const excursion_lang_container = $('#excursion_lang_container');
            const excursion_lang = $(excursion_lang_selector);

            excursion_location_container[0].classList.remove('ocultar');
            excursion_location[0].classList.add('required');
            excursion_lang_container[0].classList.remove('ocultar');
            excursion_lang[0].classList.add('required');

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // FIX (2026-08-10): bloqueo + desbloqueo garantizado mientras se busca el
            // contrato. get_contract ya informa al usuario en error/next:false.
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            safari_date.prop('disabled', false);

            // Modalidades
            let modality_selected = '';
            safari_modality.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_modality'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            product: product_type[0],
                            dealer: product_type[5]
                        };
                    },
                    type: 'GET',
                    processResults: function (data) {
                        const result = (data.rows || []).map(elem => ({ id: elem, text: elem }));
                        return { results: result };
                    }
                }
            }).on('change', function (ev) {
                modality_selected = ev.target.value;
                create_array_for_product('modalities_name', ev.target.value);
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';

                if (product_name.includes('bicicleta')) {
                    safari_pax_block[0].classList.add('ocultar');
                    safari_adult_childrens[0].classList.add('ocultar');
                    safari_cantidad_block[0].classList.remove('ocultar');

                    safari_cantidad[0].setAttribute('data-min', product_type[6]);
                    safari_cantidad[0].setAttribute('data-max', product_type[7]);
                    create_array_for_product('day_min_rent', product_type[6]);
                    create_array_for_product('day_max_rent', product_type[7]);
                    safari_cantidad.val(1).trigger('change');
                } else {
                    withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                        modality_info(product_type[5], product_type[0], modality_selected),
                        { timeout: 30000 }
                    ).then(modality => {
                        create_array_for_product('calc_amount', modality.calc_amount);
                        if (modality.info === 'true') {
                            if (modality.has_pax) {
                                safari_pax_block[0].classList.add('ocultar');
                                safari_cantidad_block[0].classList.add('ocultar');
                                safari_adult_childrens[0].classList.remove('ocultar');

                                safari_adultos[0].setAttribute('data-min', modality.min);
                                let min = 1;
                                if ((parseInt(modality.min) - 1) <= 0) min = 0;
                                safari_childrens[0].setAttribute('data-min', min);
                                safari_adultos[0].setAttribute('data-max', modality.max);
                                safari_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1));
                                safari_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                safari_childrens[0].setAttribute('data-evaluate-max', modality.max);

                                create_array_for_product('day_min_rent', min);
                                create_array_for_product('day_max_rent', modality.max);
                            } else {
                                safari_pax_block[0].classList.remove('ocultar');
                                safari_cantidad_block[0].classList.add('ocultar');
                                safari_adult_childrens[0].classList.add('ocultar');
                                safari_pax.prop('disabled', false);
                            }
                        }
                    });
                }
            });

            // Adultos / Niños
            safari_adultos.off('change').on('change', function (ev) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected, false, ev.target.value, safari_childrens.val()),
                    { timeout: 30000 }
                ).then(modality => {
                    const dataset = ev.target.dataset;
                    const helper = $(`#${dataset.helper}`);
                    if (modality.data === null) {
                        if (helper.length > 0) helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`;
                    } else {
                        if (helper.length > 0) {
                            helper[0].innerHTML = ``;
                            ev.target.classList.remove('is-invalid');
                            safari_childrens[0].classList.remove('is-invalid');
                        }
                        create_array_for_product('modality_code', modality.data.code);
                        if (modality.description !== '') {
                            safari_btn_info[0].classList.remove('ocultar');
                            safari_btn_info_desc = modality.description;
                        }
                        create_array_for_product('pax', dataset.evaluateMax);
                        create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax);
                    }
                });
            });

            safari_childrens.off('change').on('change', function (ev) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected, false, safari_adultos.val(), ev.target.value),
                    { timeout: 30000 }
                ).then(modality => {
                    const dataset = ev.target.dataset;
                    const helper = $(`#${dataset.helper}`);
                    if (modality.data === null) {
                        if (helper.length > 0) helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`;
                    } else {
                        if (helper.length > 0) {
                            helper[0].innerHTML = ``;
                            ev.target.classList.remove('is-invalid');
                            safari_adultos[0].classList.remove('is-invalid');
                        }
                        create_array_for_product('modality_code', modality.data.code);
                        if (modality.description !== '') {
                            safari_btn_info[0].classList.remove('ocultar');
                            safari_btn_info_desc = modality.description;
                        }
                        create_array_for_product('pax', dataset.evaluateMax);
                        create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax);
                    }
                });
            });

            // Cantidad
            safari_cantidad.off('change').on('change', function (ev) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected),
                    { timeout: 30000 }
                ).then(modality_by_cant => {
                    // FIX (2026-08-10): guard contra el valor neutro de modality_info (data: null en error).
                    if (!modality_by_cant || !modality_by_cant.data || !modality_by_cant.data[0]) return;
                    create_array_for_product('modality_code', modality_by_cant.data[0].code);
                    if (modality_by_cant.description !== '') {
                        safari_btn_info[0].classList.remove('ocultar');
                        safari_btn_info_desc = modality_by_cant.description;
                    }
                    create_array_for_product('pax', ev.target.value);
                    create_array_for_product('amount', ev.target.value);
                    create_id_for_product(product_type[0], product_type[3], product_type[1], modality_by_cant.data[0].code, ev.target.value);
                });
            });

            // PAX select2
            safari_pax.select2({
                theme: "bootstrap",
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pax`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            page: params.page || 1,
                            product: product_type[0],
                            dealer: product_type[5],
                            modality: modality_selected
                        };
                    },
                    type: 'GET',
                    processResults: function (data, params) {
                        params.page = params.page || 1;
                        const result = (data.rows || []).map(elem => ({ id: `${elem.id}|${elem.code}|${elem.max_reservation_amount}`, text: elem.name }));
                        const total = data.total || 0;
                        return {
                            results: result,
                            pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                        };
                    }
                }
            }).on('change', function (ev) {
                const modality_type = ev.target.value.split("|");
                create_array_for_product('modality_code', modality_type[1]);
                create_array_for_product('pax', modality_type[2]);
                create_id_for_product(product_type[0], product_type[3], product_type[1], modality_type[1], modality_type[2]);
            });

            // Calendario
            flatpickr(safari_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            safari_date.off('change').on('change', function (ev) {
                setSessionVar('from_date', ev.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', ev.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });

            safari_btn_info.off('click').on('click', function () {
                showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, safari_btn_info_desc);
            });
        });
    });
}


/* Antes de dividir archivos */
/*let safari_to, safari_date, safari_type, safari_pax_block, safari_pax,
    safari_adult_childrens, safari_adultos, safari_childrens, safari_cantidad_block,
    safari_cantidad, safari_modality, safari_btn_info, safari_btn_info_desc;
safari_to = $('#safari_to');
safari_date = $('#safari_date');
safari_type = $('#safari_type');
safari_modality = $('#safari_modality');
safari_pax_block = $('#safari_pax_block');
safari_pax = $('#safari_pax');
safari_cantidad_block = $('#safari_cantidad_block');
safari_cantidad = $('#safari_cantidad');
safari_adult_childrens = $('#safari_adult_childrens');
safari_adultos = $('#safari_adultos');
safari_childrens = $('#safari_childrens');
safari_btn_info = $('#safari_btn_info');
safari_date.prop('disabled', true);
safari_type.prop('disabled', true).select2({theme: 'bootstrap'});
safari_modality.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_modality')
});
safari_pax.prop('disabled', true).select2({theme: 'bootstrap'});

safari_to.select2({
    theme: "bootstrap",
    placeholder: I18n.t('global.main.form.select_destiny'),
    ajax: {
        url: '/destination',
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }

        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id + '|' + elem.name,
                    text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result,
                        "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result,
                    "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    let data_safari_to = e.target.value.split("|")[1];
    create_array_for_product('product_type', form_type_send.val());
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('destination_code', e.target.value.split("|")[0]);
    create_array_for_product('text_destination', e.target.value.split("|")[2]);

    safari_type.empty();
    safari_modality.empty();
    safari_pax.empty();
    safari_date.val('');
    $('#excursion_location').val('');
    excursion_lang.empty();
    safari_btn_info[0].classList.add('ocultar');
    safari_btn_info_desc = '';

    service_by_dealer(data_safari_to, form_type_send).then(
        sbd => {
            let result = [];
            sbd.services.map((elem, key) => {
                result.push({
                    id: elem.id + "|" + elem.code + "|" + elem.reservation_time + "|" + sbd.dealer_code + "|" + sbd.dealer_name + "|" + sbd.dealer_id + "|" + elem.min_reservation_amount + "|" + elem.max_reservation_amount,
                    text: elem.name
                })
            })

            safari_modality.empty();
            safari_pax_block[0].classList.remove('ocultar');
            safari_cantidad_block[0].classList.add('ocultar');
            safari_adult_childrens[0].classList.add('ocultar');
            safari_btn_info[0].classList.add('ocultar');
            safari_btn_info_desc = '';

            let product_type = result[0]['id'].split("|");
            let product_name = '';
            product_name = e.target.selectedOptions[0].innerHTML.toLowerCase();

            let excursion_location_container = $('#excursion_location_container');
            let excursion_location = $('#excursion_location');
            let excursion_lang_container = $('#excursion_lang_container');
            let excursion_lang = $('#excursion_lang');

            excursion_location_container[0].classList.remove('ocultar');
            excursion_location[0].classList.add('required');
            excursion_lang_container[0].classList.remove('ocultar');
            excursion_lang[0].classList.add('required');

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            get_contract().then(
                contract => {
                    // console.log(contract);
                }
            )

            safari_date.prop('disabled', false);

            /!* BUSCAR MODALIDADES DADO UN DEALER Y UN PRODUCTO *!/
            let modality_selected = '';
            safari_modality.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_modality'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            /!*page: params.page || 1,*!/
                            product: product_type[0],
                            dealer: product_type[5]
                        }
                    },
                    type: 'GET',
                    processResults: function (data, params) {
                        let result = [];
                        /!*params.page = params.page || 1;*!/
                        data.rows.map((elem, key) => {
                            result.push({
                                id: elem,
                                text: elem
                            })
                        })

                        /!*if (data.total > 10) {
                            if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                                return {
                                    results: result,
                                    "pagination": {
                                        "more": true
                                    }
                                }
                            } else {
                                return {
                                    results: result,
                                    "pagination": {
                                        "more": false
                                    }
                                }
                            }
                        } else {
                            return {
                                results: result,
                                "pagination": {
                                    "more": false
                                }
                            }
                        }*!/
                        return {
                            results: result
                        }
                    }
                }
            }).on('change', function (e) {
                modality_selected = e.target.value;

                create_array_for_product('modalities_name', e.target.value);
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';

                /!* OCULTANDO Y MOSTRANDO INPUTS EN DEPENDENCIA DE LO QUE NOS DEVUELVA EL SERVICIO PARA PRODUCTOS TIPO BICICLETAS *!/
                if (product_name.includes('bicicleta')) {
                    safari_pax_block[0].classList.add('ocultar');
                    safari_adult_childrens[0].classList.add('ocultar');
                    safari_cantidad_block[0].classList.remove('ocultar');

                    safari_cantidad[0].setAttribute('data-min', product_type[6]);
                    safari_cantidad[0].setAttribute('data-max', product_type[7]);
                    create_array_for_product('day_min_rent', product_type[6]);
                    create_array_for_product('day_max_rent', product_type[7]);
                    safari_cantidad.val(1);
                    safari_cantidad.trigger('change');
                } else {
                    modality_info(product_type[5], product_type[0], modality_selected).then(
                        modality => {
                            create_array_for_product('calc_amount', modality.calc_amount);
                            if (modality.info === 'true') {
                                if (modality.has_pax) {
                                    /!* OCULTANDO Y MOSTRANDO INPUTS EN DEPENDENCIA DE LO QUE NOS DEVUELVA EL SERVICIO *!/
                                    safari_pax_block[0].classList.add('ocultar');
                                    safari_cantidad_block[0].classList.add('ocultar');
                                    safari_adult_childrens[0].classList.remove('ocultar');

                                    /!* SETEANDO ATRIBUTOS A LOS INPUTS PARA EVALUAR *!/
                                    safari_adultos[0].setAttribute('data-min', modality.min);
                                    let min = 1;
                                    if ((parseInt(modality.min) - 1) <= 0) {
                                        min = 0
                                    }
                                    safari_childrens[0].setAttribute('data-min', min)
                                    safari_adultos[0].setAttribute('data-max', modality.max);
                                    safari_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1))
                                    safari_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                    safari_childrens[0].setAttribute('data-evaluate-max', modality.max)

                                    create_array_for_product('day_min_rent', min);
                                    create_array_for_product('day_max_rent', modality.max);
                                } else {
                                    safari_pax_block[0].classList.remove('ocultar');
                                    safari_cantidad_block[0].classList.add('ocultar');
                                    safari_adult_childrens[0].classList.add('ocultar');
                                    safari_pax.prop('disabled', false)
                                }
                            }
                        }
                    )
                }
            })

            /!* BUSCAR MODALIDAD POR INPUT DE ADULTOS Y NIÑOS *!/
            safari_adultos.on('change', function (e) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                modality_info(product_type[5], product_type[0], modality_selected, false, e.target.value, safari_childrens.val()).then(
                    modality => {
                        let dataset = e.target.dataset;
                        let helper = $(`#${dataset.helper}`);
                        if (modality.data === null) {
                            if (helper.length > 0) {
                                helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`
                            }
                        } else {
                            if (helper.length > 0) {
                                helper[0].innerHTML = ``;
                                e.target.classList.remove('is-invalid');
                                safari_childrens[0].classList.remove('is-invalid');
                            }
                            create_array_for_product('modality_code', modality.data.code)
                            if (modality.description !== '') {
                                safari_btn_info[0].classList.remove('ocultar');
                                safari_btn_info_desc = modality.description;
                            }
                            create_array_for_product('pax', dataset.evaluateMax);
                            create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax).then()
                        }
                    }
                );
            })

            safari_childrens.on('change', function (e) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                modality_info(product_type[5], product_type[0], modality_selected, false, safari_adultos.val(), e.target.value).then(
                    modality => {
                        let dataset = e.target.dataset;
                        let helper = $(`#${dataset.helper}`);
                        if (modality.data === null) {
                            if (helper.length > 0) {
                                helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`
                            }
                        } else {
                            if (helper.length > 0) {
                                helper[0].innerHTML = ``;
                                e.target.classList.remove('is-invalid');
                                safari_adultos[0].classList.remove('is-invalid');
                            }
                            create_array_for_product('modality_code', modality.data.code)
                            if (modality.description !== '') {
                                safari_btn_info[0].classList.remove('ocultar');
                                safari_btn_info_desc = modality.description;
                            }
                            create_array_for_product('pax', dataset.evaluateMax);
                            create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax).then()
                        }
                    }
                );
            })

            /!* SETEAR DATOS POR MODALIDAD *!/
            safari_cantidad.on('change', function (e) {
                safari_btn_info[0].classList.add('ocultar');
                safari_btn_info_desc = '';
                modality_info(product_type[5], product_type[0], modality_selected).then(
                    modality_by_cant => {
                        create_array_for_product('modality_code', modality_by_cant.data[0].code)
                        if (modality.description !== '') {
                            safari_btn_info[0].classList.remove('ocultar');
                            safari_btn_info_desc = modality.description;
                        }
                        create_array_for_product('pax', e.target.value);
                        create_array_for_product('amount', e.target.value);

                        create_id_for_product(product_type[0], product_type[3], product_type[1], modality_by_cant.data[0].code, e.target.value).then()
                    }
                )
            })

            /!* BUSCAR PAX POR MODALIDADES *!/
            safari_pax.select2({
                theme: "bootstrap",
                ajax: {
                    url: '/modalities/pax',
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            page: params.page || 1,
                            product: product_type[0],
                            dealer: product_type[5],
                            modality: modality_selected
                        }
                    },
                    type: 'GET',
                    processResults: function (data, params) {
                        let result = [];
                        params.page = params.page || 1;

                        data.rows.map((elem, key) => {
                            result.push({
                                id: elem.id + "|" + elem.code + "|" + elem.max_reservation_amount,
                                text: elem.name
                            })
                        })

                        if (data.total > 10) {
                            if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                                return {
                                    results: result,
                                    "pagination": {
                                        "more": true
                                    }
                                }
                            } else {
                                return {
                                    results: result,
                                    "pagination": {
                                        "more": false
                                    }
                                }
                            }
                        } else {
                            return {
                                results: result,
                                "pagination": {
                                    "more": false
                                }
                            }
                        }
                    }
                }
            }).on('change', function (e) {
                let modality_type = e.target.value.split("|");
                create_array_for_product('modality_code', modality_type[1])
                create_array_for_product('pax', modality_type[2]);
                create_id_for_product(product_type[0], product_type[3], product_type[1], modality_type[1], modality_type[2]).then()
            })

            flatpickr(safari_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2])),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            safari_date.on('change', function (e) {
                /!* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION *!/
                setSessionVar('from_date', e.target.value, 'add', true, false).then(
                    from => {
                        create_array_for_product('from_date', from.value);
                    }
                );
                setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                    to => {
                        create_array_for_product('to_date', to.value);
                    }
                );
            });

            safari_btn_info.on('click', function () {
                showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, safari_btn_info_desc)
            })
        }
    )
})*/
